import styled from 'styled-components';

const WorkProcessStyle = styled.div`
	.workProcessItemsWrap {
		margin-bottom: calc(-1 * var(--titleToContent));

		.workProcessItems {
			padding-top: var(--titleToText);
			border-top: 2px solid var(--color2);
			margin-bottom: var(--titleToContent);

			.iconCont {
				margin-bottom: var(--sp2x);
			}

			.infoCont {
				position: relative;

				.titleWrap {
					display: flex;

					.title {
						width: 77%;
						margin-bottom: var(--sp2x);
					}

					.icon {
						width: 33%;
						position: relative;
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSizeS}) {
			.workProcessItems {
				display: flex;

				.iconCont {
					flex: 0 0 15%;

					.icon {
						position: relative;
						padding-top: 50%;
					}
				}

				.infoCont {
					flex: 1 1 auto;

					.titleWrap {
						.title {
							width: auto;
						}
					}
				}
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.TabletSize}) {
			display: flex;
			flex-wrap: wrap;
			margin-left: calc(var(--sp2x) * -1);
			margin-right: calc(var(--sp2x) * -1);

			.workProcessItems {
				flex: 0 0 50%;
				max-width: calc(50% - var(--sp4x));
				margin-left: var(--sp2x);
				margin-right: var(--sp2x);

				.iconCont {
					flex: 0 0 24%;
				}
			}
		}

		@media only screen and (max-width: ${(props) => props.theme.mediaQuery.DesktopSizeLMin}) and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeM}) {
			.workProcessItems {
				padding-top: var(--sp5x);
			}
		}

		@media only screen and (min-width: ${(props) => props.theme.mediaQuery.DesktopSizeXL}) {
			.workProcessItems {
				max-width: calc(50% - var(--sp12x));
				margin-left: var(--sp6x);
				margin-right: var(--sp6x);
			}
		}
	}
`;

export default WorkProcessStyle;
